RivalIQ.apps.Admin.module('collections', function (collections, Admin, Backbone, Marionette, $, _) {

    'use strict';

    collections.PageTypes = Backbone.Collection.extend({
        url: '/admin/api/pagetypes'
    });
});
